<p-toast></p-toast>
<div *ngIf="isLoader" class="absLoader"></div>
@if (initailLoading) {
<div class="d-flex justify-content-center align-items-center w-100 vh-100 text-center">
  <p-progressSpinner></p-progressSpinner>
</div>
}
@else {
<app-navbar [class.scrolled]="isScrolled" class="d-flex" [ngClass]="{'headerFixed': isScrolled}"></app-navbar>

<div class="d-block h-100" data-bs-theme=light>
  <app-global-order-complete-modal></app-global-order-complete-modal>
  <router-outlet></router-outlet>
</div>

}
